var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.875.096a.563.563 0 01.25.466V9a.563.563 0 01-.353.522l-.004.001-.006.004-.026.01a25.298 25.298 0 01-1.624.562c-.919.284-2.115.588-3.05.588-.952 0-1.741-.314-2.427-.59l-.032-.011c-.713-.287-1.32-.524-2.04-.524-.788 0-1.843.26-2.742.537-.403.126-.801.262-1.196.41v6.928a.562.562 0 11-1.125 0V.563a.563.563 0 011.125 0V.88c.254-.09.558-.192.889-.293C3.432.306 4.629 0 5.563 0c.945 0 1.714.312 2.386.584l.048.02c.7.282 1.31.521 2.066.521.787 0 1.842-.259 2.741-.537.512-.16 1.019-.338 1.518-.535l.021-.008.005-.002",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_flag-05eb5494.svg";
export { SvgIcnFlag as ReactComponent };